<template>
	<div class="basic-list-loader">
		<content-loader
			:width="320"
			:height="50"
			:speed="3"
			:primaryColor="primaryColor"
			:secondaryColor="secondaryColor"
			v-for="n in 10"
			:key="n"
		>
			<rect x="0" y="0" rx="0" ry="0" width="45" height="25" />
			<rect x="12" y="74" rx="0" ry="0" width="320" height="25" />
			<rect x="58" y="0" rx="0" ry="0" width="320" height="25" />
		</content-loader>
	</div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
	components: { ContentLoader },
	computed: {
		primaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--light-gray")
				.replace(" ", "");
		},
		secondaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--main-bg-color")
				.replace(" ", "");
		},
	},
};
</script>

<style lang="scss" scoped>
.basic-list-loader {
	background: var(--white);
	padding: 10px;
}
</style>
